export default __webpack_public_path__ + "static/media/fasad7.98b81bf7.jpeg";